module.exports = __webpack_public_path__ + "static/media/2_einladen_frei.cd109bae.png";